import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  ChatCountTwixorDirective,
  ContentAnimateDirective,
  FirstLetterPipe,
  GetEntityNamePipe,
  GetObjectPipe,
  GetUserNamePipe,
  GetTaskStatusPipe,
  GetTeamPipe,
  HeaderDirective,
  JoinPipe,
  MeetingStatusPipe,
  MenuDirective,
  OffcanvasDirective,
  SafePipe,
  ScrollTopDirective,
  SparklineChartDirective,
  StickyDirective,
  TabClickEventDirective,
  TimeElapsedPipe,
  ToggleDirective,
  BackButtonDirective,
} from './_base/layout';
import { TagService } from './services/tag-service.service';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CommentsService } from './services/comments.service';
import { AuthInterceptor } from '../views/pages/auth/auth.interceptor';
import { ClientTypePipe } from './_base/layout/pipes/client-type.pipe';
import { FirstNameToNamePipe } from './_base/layout/pipes/first-name-to-name.pipe';
import { GetEntityStylePipe } from './_base/layout/pipes/get-entity-style.pipe';
import { TwixorService } from './services/twixor.service';
import { InterceptService } from './_base/crud';
import { PhoneFormatPipe } from './_base/layout/pipes/phone-format.pipe';
import { StatusColorPipe } from './_base/layout/pipes/status-color.pipe';
import { StatusPipe } from './_base/layout/pipes/status.pipe';
import { ProcessNavigatorService } from './services/process-navigator.service';
import { UserNamePipe } from './_base/layout/pipes/user-name.pipe';
import { GetUserFullNamePipe } from './_base/layout/pipes/get-user-full-name.pipe';
import { StringToArrayPipe } from './_base/layout/pipes/string-to-array.pipe';
import { HighlightedPipe } from './_base/layout/pipes/highlighted.pipe';
import { GetTitleCasePipe } from './_base/layout/pipes/get-title-case.pipe';
import { UserStatusColorPipe } from './_base/layout/pipes/user-status-color.pipe';
import { UserStatusPipe } from './_base/layout/pipes/user-status.pipe';
import { GetOfficePipe } from './_base/layout/pipes/get-office.pipe';
import { QuickCommentsService } from './services/quick-comments.service';
import { EnumFormatPipe } from './_base/layout/pipes';
import { HoverClassDirective } from './_base/layout/directives';
import { FindValueInJsonByKeyPipe } from './_base/layout/pipes/find-value-in-json-by-key.pipe';
import { TabletUtil } from './utils';
import { PhoneMaskDirective } from './_base/layout/directives/phone-mask.directive';
import { DateMaskDirective } from './_base/layout/directives/date-mask.directive';
import { DateMaskControlNameDirective } from './_base/layout/directives/date-mask-control-name.directive';
import { StripStylesPipe } from './_base/layout/pipes/strip-style.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ChatCountTwixorDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    FindValueInJsonByKeyPipe,
    PhoneFormatPipe,
    SafePipe,
    GetEntityNamePipe,
    GetUserNamePipe,
    GetTeamPipe,
    FirstLetterPipe,
    ClientTypePipe,
    FirstNameToNamePipe,
    MeetingStatusPipe,
    GetEntityStylePipe,
    GetTaskStatusPipe,
    StatusColorPipe,
    StringToArrayPipe,
    StripStylesPipe,
    StatusPipe,
    UserStatusColorPipe,
    UserStatusPipe,
    UserNamePipe,
    GetUserFullNamePipe,
    GetTitleCasePipe,
    HighlightedPipe,
    GetOfficePipe,
    EnumFormatPipe,
    HoverClassDirective,
    PhoneMaskDirective,
    DateMaskDirective,
    DateMaskControlNameDirective,
    BackButtonDirective,
  ],
  exports: [
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ChatCountTwixorDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    FindValueInJsonByKeyPipe,
    PhoneFormatPipe,
    SafePipe,
    GetEntityNamePipe,
    GetUserNamePipe,
    FirstLetterPipe,
    ClientTypePipe,
    FirstNameToNamePipe,
    GetEntityStylePipe,
    MeetingStatusPipe,
    GetTaskStatusPipe,
    GetTeamPipe,
    UserNamePipe,
    StatusPipe,
    StatusColorPipe,
    UserStatusColorPipe,
    UserStatusPipe,
    StringToArrayPipe,
    StripStylesPipe,
    GetUserFullNamePipe,
    GetTitleCasePipe,
    HighlightedPipe,
    GetOfficePipe,
    EnumFormatPipe,
    HoverClassDirective,
    PhoneMaskDirective,
    DateMaskDirective,
    DateMaskControlNameDirective,
    BackButtonDirective,
  ],
  providers: [
    TabletUtil,
    TagService,
    TitleCasePipe,
    EnumFormatPipe,
    CommentsService,
    HttpClient,
    TwixorService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
    ProcessNavigatorService,
    QuickCommentsService,
    FindValueInJsonByKeyPipe,
  ],
})
export class CoreModule {}
